import React from 'react';
import clsx from 'clsx';
import { DivPropsWithoutRef } from '../../common';

export interface DropdownMenuGroupProps
  extends Omit<DivPropsWithoutRef, 'title'> {
  /**
   * Слот для заголовка
   */
  title?: React.ReactNode;
  /**
   * Слот для содержимого
   */
  children?: React.ReactNode;
}

export const DropdownMenuGroup: React.FC<DropdownMenuGroupProps> = ({
  title,
  children,
  className,
  ...props
}) => {
  return (
    <div className={clsx('hse-DropdownMenuGroup', className)} {...props}>
      <div className="hse-DropdownMenuGroup__title">{title}</div>
      <div className="hse-DropdownMenuGroup__subitems">{children}</div>
    </div>
  );
};
